<template>
  <div class="type_search">
      <div class="type">
        <ul>
            <!-- <li>License ID</li>
            <li>项目名称</li>
            <li>申请工单号</li>
            <li>申请人</li>
            <li>最终客户</li> -->
            <li v-for="(item,index) in contentType" :key="index" :class='index==selected?"selected":""'><span @click="getType(item,index)" style="margin-right:16px;cursor: pointer;">{{item.text}}</span><span style="color:#E0E0E0">|</span></li>
        </ul>
      </div>
      <div class="search_input_box">
          <!-- <input v-model.trim="chooosedResult" type="text" ref="search_text" @input="handleChange" placeholder="请输入搜索内容"> -->
          <input v-model.trim="chooosedResult" type="text" ref="search_text" @input="toInput"  placeholder="请输入搜索内容"  @keydown="clcikEnterToSearch($event)" >
          <!-- <div class="icon-search search" @click="handleChange"></div> -->
      </div>
      <div class="scroll_box">
        <a-spin :spinning="spinning">
          <vuescroll ref="scrollDiv" :ops="ops" @load-start="handleLoadStart">
            <div class="search_content_box" @scroll="toScroll">
              <div class="search_result_list" @click="getResultInType(item,index)" v-for="(item,index) in searchResultList" :key="index"><a-tooltip :title="item" placement="topLeft">{{item}}</a-tooltip></div>
              <p class="empty_data" v-show="searchResultList.length == 0 "></p>
            </div>
          </vuescroll>
        </a-spin>
      </div>
  </div>
</template>

<script>
import '../../less/selectSearch/selectSearch.less'
import manage_service from '../../model/manage_service.js'
import { Select, Spin, Message, Tooltip } from 'ant-design-vue'
import vuescroll from 'vuescroll'
import { debounce } from '@/util/utils.js'
import { createNamespacedHelpers } from 'vuex'
const { mapActions,mapMutations,mapState } = createNamespacedHelpers('manage')

export default {
  data () {
    return {
      canPull: true,
      spinning: false,
      ops:{
        bar:{
          background: "#888888",
          disable: true
        },
        vuescroll: {
          mode: 'slide',
          pushLoad: {
            enable: true,
            auto: true,
            autoLoadDistance: 10,
            tips: {
              deactive: '下拉刷新',
              active: '释放刷新',
              start: '刷新中...',
              beforeDeactive: '刷新成功!'
            }
          }
        }
      },
      showResult:false,
      contentType:[
        {
          value:"1",
          text:"License ID",
          key:"licenseId"
        },
        {
          value:"2",
          text:"项目名称",
          key:"projectName"
        },
        {
          value:"3",
          text:"申请工单号",
          key:"orderNo"
        },
        {
          value:"4",
          text:"申请人",
          key:"applicantName"
        },
        {
          value:"5",
          text:"最终客户",
          key:"customerName"
        }
      ],
      choosedType:"1",// 默认无搜索类型,
      contentTypeText:"License ID",
      pageNo: 1,
	    pageSize: 20,
      clickKey:"licenseId",
      selected:0,
      searchResultList:[],
      chooosedResult:"",
      currentCombinedBlock:""
    }
  },
  created(){
    this.toScroll = debounce(this.handleScroll, 500)
    this.toInput = debounce(this.handleInput, 500)
  },
  computed:{
    ...mapState(['isClickTypeFlag']),
  },
  methods:{
    ...mapActions(['queryDataInType']),
    ...mapMutations(['alreadyClickType']),
    handleLoadStart (vm, refreshDom, done) {
      this.pageNo += 1
      if (this.canPull) {
        this.search()
      }
      setTimeout(() => {
        done()
      }, 100)
    },
    handleScroll (e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight === e.srcElement.scrollHeight) {
        this.$refs['scrollDiv'].triggerRefreshOrLoad('load')
      }
    },
    getType(item,index){
      if(item){
        this.alreadyClickType(true)
        //
        if(this.isClickTypeFlag === true){
          this.selected=index;
          this.choosedType=item.value;
          this.contentTypeText=item.text;
          this.clickKey = item.key
        }
        this.$emit("transferClickType", this.choosedType)
        this.$emit("transferClickKey",this.clickKey)
      }
    },
    // 根据输入框的字段 查询结果显示在下拉列表中
    async search(){
      this.showResult=true;
      var type =  this.choosedType;
      var key = this.clickKey
      let inputedValue = this.$refs.search_text.value.trim();
      let params = {
        searchIndex: this.choosedType,
        searchText: inputedValue,
        pageNo: this.pageNo,
	      pageSize: this.pageSize
      }
      if(inputedValue){
        this.spinning = true
        const result = await this.queryDataInType(params)
        this.spinning = false
        let allSearchData = []
        if(result.pageNo*result.pageSize >= result.totalRecord){
          this.canPull = false
        }
        if (result && result.results && result.results.length) {
          result.results.forEach((item) => {
            allSearchData.push(item[key])
          })
        }
        this.searchResultList = this.searchResultList.concat(allSearchData)
      }
    },
    handleInput(){
      if(typeof this.chooosedResult === 'string'){
        this.pageNo = 1
        this.searchResultList=[]
        this.canPull = true
        this.search()
      }
    },
    // 回车搜索
    clcikEnterToSearch(event){
      if(event.keyCode == 13){
        this.pageNo = 1
        this.searchResultList=[]
        this.canPull = true
        this.search();
      }
    },
    // 手动点击放大镜搜索
    handleChange(){
      let flag = false
      // if(this.isClickTypeFlag){
        if(this.chooosedResult){
          this.search();
          flag=true
        }
        else{

        }
      // }
      // else{
      //    this.$message.warning('请先选择类型，再进行检索');
      // }
    },
    getResultInType(item,index){
      // this.chooosedResult = item
      var obj = {};
      obj.combindedBlock=this.contentTypeText+":"+item;
      this.currentCombinedBlock=this.contentTypeText+":"+item;
      obj.params = this.clickKey
      obj.paramsValue = item
      this.$emit("transferCombinedContent", obj)
    }
  },
  watch:{
    selected (newValue, oldValue) {
      this.chooosedResult=""
      this.searchResultList=[]
    }
  },
  components:{
      ASelect: Select,
      ASelectOption: Select.Option,
      ASpin: Spin,
      ATooltip: Tooltip,
      vuescroll
  }
}
</script>

<style>

</style>
